import { __ } from 'bits/intl'

export const CONFIRM_DISCARD_CHANGES: { [key: string]: string } = {
  title: __('You have unsaved changes'),
  body: __('Are you sure you want to discard them and close this panel?'),
  confirmButtonText: __('Discard and close'),
  cancelButtonText: __('Keep working'),
}

export default {
  CONFIRM_DISCARD_CHANGES,
}
